// export const url ="http://localhost:4000";
// export const url ="http://77.37.45.124:4000";
export const url =process.env.REACT_APP_API_URL;

// console.log("API URL SET TO -", url );